import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import IconStarEmpty from '@adv-mt/mt-svg-icons/lib/StarEmpty'

const CHECKED_ID = 'checked'
const UNCHECKED_ID = 'unchecked'
const CHECKED_RATING_VALUE = {from: 4, to: 5}
const UNCHECKED_RATING_VALUE = {from: null, to: null}

const FormRating = ({onChange, type, value, withLabel, wrapper}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('searchFilters')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const handleChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.RATING,
      value: value === CHECKED_ID ? CHECKED_RATING_VALUE : UNCHECKED_RATING_VALUE,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.RATING]
    })
  }

  const handleChecked = ({value: selectedValue}) => {
    const [currentValue] = selectedValue

    handleChange(null, {value: currentValue})
  }

  const iconLabel = (
    <span className="mt-FormRating-labelIconWrapper">
      <IconStarEmpty />
    </span>
  )

  return (
    <FilterWrapperBasic
      filters={[
        {
          name: FILTER_NAMES.RATING,
          options: [{id: CHECKED_ID, label: i18n.t('FORM.RATING')}],
          type,
          nodeLabel: iconLabel,
          label: i18n.t('DEALER_RATINGS.FILTER.LABEL'),
          showLabel: true
        }
      ]}
      group={`${FILTER_NAMES.RATING}Group`}
      helpText={i18n.t('DEALER_RATINGS.FILTER.HELP_TEXT')}
      legend={i18n.t('DEALER_RATINGS.FILTER.LABEL')}
      legendIcon={iconLabel}
      onChange={handleChecked}
      showLegend={withLabel}
      value={{
        [FILTER_NAMES.RATING]: [
          value?.from === CHECKED_RATING_VALUE.from && value?.to === CHECKED_RATING_VALUE.to ? CHECKED_ID : UNCHECKED_ID
        ]
      }}
      wrapper={wrapper}
    />
  )
}

FormRating.displayName = 'FormRating'
FormRating.propTypes = {
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.bool,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}
export default FormRating
